<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (errorMessage$ | async; as msg) {
  <pidx-inline-form-messages [messages]="[msg | translate]"></pidx-inline-form-messages>
}

<profile-pds-p-text p-text id="required-fields-hint">{{ 'pidaw.generic.form.requiredFields.hint' | translate }}</profile-pds-p-text>

<form
  [formGroup]="formGroup"
  class="profile:mt-fluid-md"
  myprofileUiValidationTrack="address_editform"
  id="form"
  [attr.aria-label]="'pidpaw.editAddress.headline.editAddress' | translate"
  aria-describedby="required-fields-hint"
>
  <dynamic-form
    class="profile:container"
    [group]="formGroup"
    [model]="formModel"
    [layout]="(layout$ | async) ?? {}"
    [token]="token"
    (metaDataSelectedEvent)="addressAutocompleteResultSelected($event)"
  ></dynamic-form>

  @if (deleteButtonLabel && addressIdBeingEdited) {
    <profile-pds-p-button-pure
      [aria]="{
        'aria-label': ('pidpaw.editAddress.button.deleteAddress.label' | translate),
        'aria-haspopup': 'dialog',
      }"
      p-button-pure
      icon="delete"
      (click)="deleteAddress()"
      data-protractor-id="address-widget-editor-delete-address-button"
      class="profile:mt-fluid-sm profile:py-fluid-sm"
      [myprofileUiTrack]="{
        clickElementType: 'button',
        clickElementId: 'address',
        clickElementName: 'delete',
      }"
    >
      {{ deleteButtonLabel }}
    </profile-pds-p-button-pure>
  }

  @if ((isBlankCheckoutModeEditor$ | async) === false) {
    <div class="profile:flex profile:flex-col profile:gap-y-fluid-sm profile:sm:gap-x-static-sm profile:sm:flex-row profile:mt-fluid-md">
      <profile-pds-p-button
        [aria]="{ 'aria-label': ('pidpaw.editAddress.button.save.aria' | translate) }"
        p-button
        variant="primary"
        (click)="submitForm(formGroup)"
        icon="check"
        data-protractor-id="address-widget-editor-save-address-button"
        [myprofileUiTrack]="{
          clickElementType: 'button',
          clickElementId: 'address',
          clickElementName: 'save',
        }"
      >
        {{ saveButtonLabel }}
      </profile-pds-p-button>
      <profile-pds-p-button
        [aria]="{ 'aria-label': ('pidpaw.editAddress.button.cancel.aria' | translate) }"
        p-button
        variant="secondary"
        (click)="cancel()"
        icon="close"
        data-protractor-id="address-widget-editor-cancel-button"
        [myprofileUiTrack]="{
          clickElementType: 'button',
          clickElementId: 'address',
          clickElementName: 'cancel',
        }"
      >
        {{ cancelButtonLabel }}
      </profile-pds-p-button>
    </div>
  }

  @if (isBlankCheckoutModeEditor$ | async) {
    <div class="profile:flex profile:flex-col profile:gap-y-fluid-sm profile:sm:gap-x-fluid-sm profile:sm:flex-row profile:mt-fluid-md">
      <profile-pds-p-button
        [aria]="{ 'aria-label': ('pidpaw.editAddress.button.saveAndContinue.aria' | translate) }"
        p-button
        (click)="submitForm(formGroup)"
        icon="check"
        data-protractor-id="address-widget-blank-editor-save-and-continue"
      >
        {{ saveAndContinueButtonLabel }}
      </profile-pds-p-button>
    </div>
  }
</form>

@if (editorIsLoading$ | async) {
  <pidx-loader
    [mode]="PidxLoaderModeEnum.OVERLAY"
    [text]="editorLoadingLabel"
    data-protractor-id="address-widget-editor-overlay-loader"
  ></pidx-loader>
}
